import { Component, ErrorInfo, ReactNode, useEffect } from 'react';
import HeroSlider from "@/components/sections/hero-slider";
import CompanyStory from "@/components/sections/company-story";
import ApproachSection from "@/components/sections/approach-section";
import CompanyBenefits from "@/components/sections/company-benefits";
import SectorsShowcase from "@/components/sections/sectors-showcase";
import ClientInitiativesSection from "@/components/sections/client-initiatives";
import VideoShowcase from "@/components/sections/video-showcase";
import TestimonialsCarousel from "@/components/sections/testimonials-carousel";
import BlogArticles from "@/components/sections/blog-articles";
import InstagramGallery from "@/components/sections/instagram-gallery";

interface ErrorBoundaryProps {
  children: ReactNode;
  componentName: string;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error(`Error in ${this.props.componentName}:`, error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: '20px', border: '2px solid red', margin: '10px', backgroundColor: '#fff3f3' }}>
          <h3 style={{ color: 'red' }}>Error in {this.props.componentName}</h3>
          <p>{this.state.error?.message}</p>
          <details>
            <summary>Stack trace</summary>
            <pre style={{ fontSize: '12px', overflow: 'auto' }}>{this.state.error?.stack}</pre>
          </details>
        </div>
      );
    }

    return this.props.children;
  }
}

function HomePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="overflow-x-hidden w-full">
      <ErrorBoundary componentName="HeroSlider">
        <HeroSlider />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="CompanyStory">
        <CompanyStory />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="VideoShowcase">
        <VideoShowcase />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="ApproachSection">
        <ApproachSection />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="CompanyBenefits">
        <CompanyBenefits />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="SectorsShowcase">
        <SectorsShowcase />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="ClientInitiativesSection">
        <ClientInitiativesSection />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="TestimonialsCarousel">
        <TestimonialsCarousel />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="BlogArticles">
        <BlogArticles />
      </ErrorBoundary>
      
      <ErrorBoundary componentName="InstagramGallery">
        <InstagramGallery />
      </ErrorBoundary>
    </main>
  );
}

export default HomePage;

